import { render, staticRenderFns } from "./OzlOrderDialog.vue?vue&type=template&id=8dde5360"
import script from "./OzlOrderDialog.vue?vue&type=script&lang=js"
export * from "./OzlOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports